import React, { useRef } from "react";
import RadioButton from "components/ui/RadioButton";
import t from "lib/i18n";

import useModal from "hooks/useModal";
import FeatureFlag from "components/helpers/FeatureFlag";
import A11yElement from "components/helpers/A11yElement";
import SmartCarnetInfoModal from "components/others/SmartCarnetInfoModal";
import { TICKET_TYPES } from "consts";

const TicketOptions = ({ setFieldValue, ticketType }) => {
  const { closeModal, showModal } = useModal();
  const smartCarnetFindOutMore = useRef();

  const handleCarnetFindMore = () => {
    showModal(<SmartCarnetInfoModal closeModal={closeModal} />, { autoFocus: false });
  };

  return (
    <div className="otrl-jp__other__options">
      <div
        className="otrl-jp__other__journey-type"
        role="radiogroup"
        aria-label={t("tickets.radio.aria")}
      >
        <FeatureFlag name="enableSmartCarnet">
          <RadioButton
            name="ticketType"
            label={t("tickets.smart.carnet.radio")}
            subTitle={
              <span>
                <p>{t("tickets.smart.carnet.radio.subtitle-1")}</p>
                <p>{t("tickets.smart.carnet.radio.subtitle-2")}</p>
                <A11yElement
                  className="otrl-jp__other__smart-carnet__find-more-wrapper"
                  onAction={handleCarnetFindMore}
                  ref={smartCarnetFindOutMore}
                >
                  <span
                    className="otrl-jp__button-link otrl-jp__other__smart-carnet__find-more"
                    onClick={handleCarnetFindMore}
                  >
                    {t("tickets.smart.carnet.find-more")}
                  </span>
                </A11yElement>
              </span>
            }
            onChange={() => setFieldValue(TICKET_TYPES.SMART_CARNET)}
            selected={ticketType}
            value={TICKET_TYPES.SMART_CARNET}
          />
        </FeatureFlag>
        <FeatureFlag name="enableRoversRangers">
          <RadioButton
            name="ticketType"
            label={t("tickets.rover.radio")}
            subTitle={t("tickets.rover.radio.subtitle")}
            onChange={() => setFieldValue("rovers")}
            selected={ticketType}
            value="rovers"
          />
        </FeatureFlag>
        <FeatureFlag name="enableDaySave">
          <RadioButton
            name="ticketType"
            label={t("tickets.daysave.radio")}
            subTitle={t("tickets.daysave.radio.subtitle")}
            onChange={() => setFieldValue("daysave")}
            selected={ticketType}
            value="daysave"
          />
        </FeatureFlag>
      </div>
    </div>
  );
};

export default React.memo(TicketOptions);
